<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    :before-close="handleClose"
    :custom-class="isH5 ? 'login-dialog-modern-wrapper login-dialog-modern-wrapper--h5' : 'login-dialog-modern-wrapper'"
    append-to-body
    :fullscreen="isH5"
    :width="equityConfigVisible ? '880px' : '440px'"
    :top="0"
    :close-on-click-modal="true"
  >
    <!-- Modal Card -->
    <div
      class="login-dialog-modern__card"
      :class="{
        'login-dialog-modern__card--equity': equityConfigVisible,
        'login-dialog-modern__card--h5': isH5,
      }"
    >
      <!-- Close Button -->
      <button
        class="login-dialog-modern__close"
        @click="handleClose"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>

      <div class="login-dialog-modern__content">
        <!-- Equity list (left side when equity mode) -->
        <div class="equity-list" v-if="equityConfigVisible">
          <div
            class="equity-list__title"
            :class="{
              'equity-list__title__few':
                equityConfig.equity_list && equityConfig.equity_list.length < 5,
            }"
          >
            <span>{{ equityConfig.settled_title }}</span>
          </div>
          <div
            class="equity-item"
            :class="{
              'equity-item__no__icon__style': !isHaveIcon,
            }"
            v-for="item in equityConfig.equity_list || []"
            :key="item.id"
          >
            <div
              class="equity-item__icon"
              :class="{ 'equity-item__icon__no_icon': !item.icon }"
            >
              <img :src="item.icon" alt="" />
            </div>
            <div class="equity-item__content">
              <div class="equity-item__title">{{ item.title }}</div>
              <div class="equity-item__instructions">{{ item.instructions }}</div>
            </div>
          </div>
        </div>

        <!-- Login box -->
        <login-box v-if="dialogVisible"></login-box>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import LoginBox from "../Index.vue";
import { isH5 } from "@saas/components/src";
import { getEquity } from "@saas/server-api/src/settle-in";
import { uploadLiveLog, forceFlushLogs } from "@saas/components/src/utils/log";
export default {
  components: {
    LoginBox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: () => {},
    },
    isShowEquity: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    equityConfigVisible() {
      return (
        this.isShowEquity &&
        !this.isH5 &&
        this.equityConfig.equity_list &&
        this.equityConfig.equity_list.length
      );
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          if (this.isShowEquity) {
            this.getEquity();
          }
          document.querySelector("#app").style.overflow = "hidden";
        } else {
          document.querySelector("#app").style.overflow = "auto";
        }
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      isH5: isH5(),
      equityConfig: {},
      isHaveIcon: false,
    };
  },
  mounted() {
    uploadLiveLog({
      message: "登录对话框加载",
      module: "login",
      level: "info",
      tag: "pageLoad",
      extra: {
        component: "LoginDialog",
        isShowEquity: this.isShowEquity,
        isH5: this.isH5,
      },
    });
  },
  beforeDestroy() {
    forceFlushLogs().catch((err) => {
      console.error("页面销毁前上传日志失败:", err);
    });
  },
  methods: {
    handleClose() {
      uploadLiveLog({
        message: "关闭登录对话框",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "LoginDialog",
        },
      }, true);

      this.dialogVisible = false;
      this.close();
      document.querySelector("#app").style.overflow = "auto";
    },
    getEquity() {
      uploadLiveLog({
        message: "获取权益配置",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "LoginDialog",
        },
      }, true);

      getEquity().then((res) => {
        if (res.code === 1) {
          uploadLiveLog({
            message: "获取权益配置成功",
            module: "login",
            level: "info",
            tag: "userAction",
            extra: {
              component: "LoginDialog",
              equityCount: (res.data?.equity_list || []).length,
            },
          }, true);

          this.equityConfig = res.data || {
            settled_title: "",
            equity_list: [],
          };
          this.isHaveIcon = (this.equityConfig.equity_list || []).some(
            (item) => item.icon
          );
        } else {
          uploadLiveLog({
            message: "获取权益配置失败",
            module: "login",
            level: "error",
            tag: "userAction",
            extra: {
              component: "LoginDialog",
              errorCode: res.code,
              errorMessage: res.message,
            },
          }, true);
          this.$message.error(res.message);
        }
      }).catch((error) => {
        uploadLiveLog({
          message: "获取权益配置异常",
          module: "login",
          level: "error",
          tag: "userAction",
          extra: {
            component: "LoginDialog",
            error: error?.message || String(error),
          },
        }, true);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-dialog-modern__card {
    position: relative;
    background: #fff;
    border-radius: 2.5rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 440px;
    overflow: hidden;
    animation: modal-scale-in 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transition: background-color 0.3s, border-color 0.3s;

    // 暗色模式 — 深灰卡片
    html.dark & {
      background: #0f172a !important; // slate-900
      border: 1px solid #1e293b !important; // slate-800
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6) !important;
    }

    // Equity mode: wider
    &.login-dialog-modern__card--equity {
      max-width: 840px;
      height: 580px;

      .login-dialog-modern__content {
        display: flex;
        flex-direction: row;
        height: 100%;
        overflow: hidden;
      }

      .equity-list {
        background: #f3fffa;
        background-image: url("../../../assets/images/login/bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 420px;
        flex-shrink: 0;

        // 暗色模式
        html.dark & {
          background: #1a2030 !important;
          background-image: none !important;
        }
      }

      .login-container {
        flex: 1;
      }
    }

    // H5 mode: full screen
    &.login-dialog-modern__card--h5 {
      max-width: 100%;
      height: 100%;
      border-radius: 0;
    }
  }

  .login-dialog-modern__close {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 30;
    padding: 8px;
    color: #94a3b8;
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #475569;
      background: #f1f5f9;
    }

    // 暗色模式
    html.dark & {
      color: #64748b;

      &:hover {
        background: #1e293b;
        color: #f1f5f9;
      }
    }
  }

  // Equity list styles (preserved from original)
  .equity-list {
    .equity-list__title {
      margin-top: 52px;
      margin-bottom: 5px;
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      height: 37px;
      line-height: 37px;
      text-align: center;
      span {
        position: relative;
        font-weight: 500;
        font-size: 26px;
        color: #000000;
        height: 37px;
        line-height: 37px;
        text-align: center;
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: -48px;
          transform: translateY(-50%);
          width: 44px;
          height: 24px;
          background: url("../../../assets/images/login/timeLimit.png");
          background-size: 100% 100%;
        }
      }
    }
    .equity-list__title__few {
      margin-bottom: 55px;
    }
    .equity-item {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .equity-item__icon {
        width: 50px;
        height: 50px;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .equity-item__icon__no_icon {
        visibility: hidden;
      }
      .equity-item__content {
        width: 240px;
        .equity-item__title {
          font-weight: 600;
          font-size: 16px;
          color: #0d1400;
          line-height: 22px;
        }
        .equity-item__instructions {
          margin-top: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #575859;
          line-height: 17px;
        }
      }
    }
    .equity-item__no__icon__style {
      .equity-item__icon {
        display: none;
      }
    }
}

@keyframes modal-scale-in {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
<style lang="scss">
.login-dialog-modern-wrapper {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100vh;
  
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
  }
}

.login-dialog-modern-wrapper--h5 {
  display: block!important;
  .el-dialog__body {
    height: 100%;
    overflow-y: auto;
  }
}

/* Override login-container styles inside modern dialog */
.login-dialog-modern__card {
  .login-container {
    .input-account {
      .close-btn {
        display: none;
      }
    }
    .input-container {
      width: 100%;
      min-width: 100%;
      align-items: flex-start;
      .comp-container {
        box-shadow: unset;
      }
    }
  }
}
</style>
